export default __webpack_public_path__ + "static/media/square.cce9d562.svg";